export default __webpack_public_path__ + "static/media/033-pray.71b11190.svg";